// extracted by mini-css-extract-plugin
module.exports = {"footer-common-link":"FooterCommonLink_footer-common-link__vo11_"};